import BaseZoomControls from "../../components/ZoomControls";

interface ZoomControlsProps {
  zoom: {
    scale: (scaleParams: { scaleX: number; scaleY: number }) => void;
    reset: () => void;
  };
}

const ZoomControls = ({ zoom }: ZoomControlsProps) => {
  return (
    <BaseZoomControls
      onZoomIn={() => zoom.scale({ scaleX: 1.2, scaleY: 1.2 })}
      onZoomOut={() => zoom.scale({ scaleX: 0.8, scaleY: 0.8 })}
      onReset={() => zoom.reset()}
    />
  );
};
export default ZoomControls;
